<script>
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import Multiselect from "vue-multiselect";
import bookingMixin from "@/mixins/bookingMixin";
import telefonoDelHuesped from "@/mixins/telefonoDelHuesped";
import LoaderModal from "@/components/Loaders/loaderModal.vue";
import axios from "axios";
import { $toast } from "@/utils/useToast";
import { buscarClientes, listarClientes } from "@/services/clientesDirectorio";

export default {
  mixins: [bookingMixin, telefonoDelHuesped],
  props: {
    selectedRange: {
      type: Object,
      required: false,
      default: () => ({ start: null, end: null }),
    },
    bookingToEdit: {
      type: Object,
      default: null,
    },
    roomTypes: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    VueTelInput,
    LoaderModal,
    Multiselect,
  },
  data() {
    return {
      errors: {},
      resendConfirmation: false,
      selectedPropertyName: null,
      selectedProperty: null,
      isHotel: false,
      isOtaBooking: false,
      // La reserva vive en Channex (llegó por su webhook): se puede mudar a cualquier
      // apartamento de la cuenta. Las de iCal, no (ver destinosDeLaReservaDelCanal).
      viveEnChannex: false,
      defaultCountryCode: "ES",

      showModal: false,
      name: "",
      surname: "",
      startDate: null,
      endDate: null,
      email: "",
      phone: "",
      number_of_guests: 1,
      price: 0,
      currency: "EUR",
      quantity: 1,
      template: {},
      ratePlans: [],

      guestSuggestions: [],
      showGuestSuggestions: false,
      selectedGuestSuggestionId: null,
      guestSearchLoading: false,
      guestSearchDebounce: null,
      guestPickerQuery: "",

      isEditing: false,
      bookingId: null,
      originalStartDate: null,
      originalEndDate: null,
      originalPropertyId: null,
      originalPrice: 0,

      Loader: false,
      isSubmitting: false,
      btnPriceDisable: false,
      changePriceBlock: false,

      promotions: [],
      taxes: [],
      subtotal: 0,
      total: 0,
      priceNight: 0,

      // Lo que cobraría la reserva directa por esta estancia: noches, huésped extra,
      // limpieza y cargos del anfitrión. Una línea por alojamiento, porque una misma
      // reserva puede ocupar varios del mismo anuncio.
      cotizaciones: [],
      cotizando: false,
      // Lo que el operador ha decidido cobrar (y descontar) en cada alojamiento:
      // { [property_id]: { conLimpieza, cargos: [títulos], conExtra, conDescuento, descuento } }
      // Todo en falso de salida: el precio son las noches y de ahí solo sube lo que marque.
      opciones: {},
      // Alojamientos añadidos además del principal: [{ property_id, guests }]
      unidadesExtra: [],
      // Precio escrito a mano por alojamiento: { [property_id]: number }
      preciosAMano: {},
      // En cuanto escribe un precio a mano, manda él: ningún recálculo se lo pisa.
      precioAMano: false,
      // «Otras opciones»: apagado de salida. Al encenderlo salen la limpieza y los
      // cargos configurados para marcarlos uno a uno.
      otrasOpciones: false,

      availabilityInfo: null,
      availabilityError: null,
      minStayRequired: null,
      minStaySource: null,
      minStayWarning: null,

      debounceTimer: null,
      lastTemplateIdLoaded: null,
      templateCache: Object.create(null),
      ctrl: {
        getProperty: null,
        calcPrice: null,
        minStay: null,
        hotelAvail: null,
      },
      isBooting: true,
    };
  },

  mounted() {
    this.isBooting = true;
    this._safeSetFromStore();

    this.applySelectedRangePrefill(this.selectedRange);

    document.addEventListener("click", this.handleOutsideGuestSuggestions);
    this.$root.$on("crear-reserva-para-cliente", this.applyGuestSuggestion);
    this.isBooting = false;
    this._scheduleRecalc(0);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideGuestSuggestions);
    this.$root.$off("crear-reserva-para-cliente", this.applyGuestSuggestion);

    if (this.guestSearchDebounce) clearTimeout(this.guestSearchDebounce);
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  },

  computed: {
    /* ¿Esconderle los importes a quien mira? (perfil coanfitrión) */
    ocultaImportes() {
      return this.$store.getters.ocultaImportes;
    },

    modalTitle() {
      return this.isEditing
        ? this.$t("modal.modifyTitle")
        : this.$t("modal.createTitle");
    },

    saveButtonLabel() {
      return this.isEditing
        ? this.$t("modal.modifyAction")
        : this.$t("modal.createAction");
    },

    isModalVisible() {
      return this.$store.state.isVisibleModalBooking;
    },

    minDate() {
      return new Date().toISOString().split("T")[0];
    },

    minEndDate() {
      if (!this.startDate) return this.minDate;

      const d = this.parseLocalYMD(this.startDate);
      if (!d || isNaN(d.getTime())) return this.minDate;

      d.setDate(d.getDate() + 1);
      return this.toDateInput(d);
    },

    properties() {
      return this.$store.state.property.properties;
    },

    selectedPropertyGlobal() {
      const propertySelect = this.$store.state.propertySelect || null;
      const propiedadActiva = this.$store.state.propiedadActiva || null;
      return propertySelect || propiedadActiva;
    },

    selectedRoomTypeInfo() {
      return this.isHotel
        ? this.roomTypes.find(
            (r) => Number(r.id) === Number(this.selectedProperty)
          ) || {}
        : (this.properties || []).find(
            (p) => Number(p.id) === Number(this.selectedProperty)
          ) || {};
    },

    user() {
      return this.$store.state.userRoot;
    },

    nightsSelected() {
      if (!this.startDate || !this.endDate) return 0;

      const s = this.parseLocalYMD(this.startDate);
      const e = this.parseLocalYMD(this.endDate);
      if (!s || !e) return 0;

      const ms = e - s;
      return ms > 0 ? Math.round(ms / (1000 * 60 * 60 * 24)) : 0;
    },

    formattedProperties() {
      return (this.properties || [])
        // Este modal gestiona APARTAMENTOS; los hoteles (propiedades con
        // habitaciones) se gestionan con su propio modal. No listarlos aquí.
        .filter((prop) => !this.isHotelProperty(prop))
        .map((prop) => ({
          ...prop,
          displayName: prop.internalName
            ? `${prop.internalName} - ${prop.nombre}`
            : prop.nombre,
        }));
    },

    /**
     * Alojamientos HERMANOS: los del mismo anuncio que el de la reserva.
     *
     * Es a donde se puede mudar una reserva que administra el canal. Para Channex, los
     * alojamientos de un mismo anuncio son room types de UNA propiedad, así que mover al
     * huésped de uno a otro es algo que sabe hacer y que le podemos contar; saltar a otro
     * anuncio sería otra propiedad suya, y ahí la reserva no se puede mover.
     */
    hermanosDelAnuncio() {
      const origen = (this.properties || []).find(
        (prop) => Number(prop.id) === Number(this.originalPropertyId)
      );

      if (!origen) return [];

      const anuncio = origen.listing_id ?? null;
      if (!anuncio) return [];

      return this.formattedProperties.filter((prop) => Number(prop.listing_id) === Number(anuncio));
    },

    /**
     * ¿Se le puede cambiar el alojamiento a ESTA reserva?
     *
     * Las de OTA tienen el resto congelado —fechas, precio, cantidad— porque las
     * administra el canal, pero el alojamiento sí: un apartamento se rompe, se inunda o
     * simplemente conviene otro, y cancelar la reserva de Booking para volver a crearla
     * es perder al huésped. Solo entre hermanos, y solo si hay más de uno.
     */
    puedeMudarseDeAlojamiento() {
      return this.isEditing
        && this.isOtaBooking
        && !this.isHotel
        && this.destinosDeLaReservaDelCanal.length > 1;
    },

    /**
     * A dónde puede ir una reserva del canal.
     *
     * Si vive en Channex, a CUALQUIER apartamento de la cuenta (lo pidió Alexis el 7-oct
     * para llevar el control: reubicar en Marquesa Pinares dos sobreventas de Arenas del
     * Coliseo). Dentro del mismo anuncio el servidor se lo cuenta al canal por CRS; en
     * otro anuncio queda reubicada y el canal la sigue teniendo donde la vendió. Las de
     * iCal, solo entre hermanos: su calendario las volvería a crear en el suyo.
     */
    destinosDeLaReservaDelCanal() {
      return this.viveEnChannex ? this.formattedProperties : this.hermanosDelAnuncio;
    },

    /** ¿El destino elegido es de OTRO anuncio? Entonces el canal no se entera del cambio. */
    seReubicaFueraDelAnuncio() {
      if (!this.puedeMudarseDeAlojamiento) return false;
      const props = this.properties || [];
      const origen = props.find((p) => Number(p.id) === Number(this.originalPropertyId));
      const destino = props.find((p) => Number(p.id) === Number(this.selectedProperty));
      if (!origen || !destino || Number(origen.id) === Number(destino.id)) return false;
      return Number(origen.listing_id || 0) !== Number(destino.listing_id || 0);
    },

    /** Lo que se ofrece en el desplegable según lo que se esté haciendo. */
    opcionesDeAlojamiento() {
      if (this.isHotel) return this.formattedRoomTypes;

      return this.puedeMudarseDeAlojamiento ? this.destinosDeLaReservaDelCanal : this.formattedProperties;
    },

    formattedRoomTypes() {
      return (this.roomTypes || []).map((room) => ({
        ...room,
        displayName: room.internalName
          ? `${room.name} - ${room.internalName}`
          : room.name,
      }));
    },

    minStayBannerText() {
      const x = this.minStayRequired;
      if (!x || !this.startDate) return null;

      const y = this.nightsSelected;
      if (y > 0 && y < x) {
        const n = (v) =>
          v === 1
            ? this.$t("bookingsHc.rerservationModal.night")
            : this.$t("bookingsHc.rerservationModal.nights");
        return this.$t("bookingsHc.rerservationModal.minStayBanner", {
          count: x,
          nights: n(x),
          selected: y,
        });
      }
      return null;
    },

    availabilityBannerText() {
      const info = this.availabilityInfo;
      if (!this.startDate || !this.endDate) return null;

      if (this.availabilityError) return this.availabilityError;

      if (info && info.available === false) {
        const parts = [];
        if (typeof info.available_units !== "undefined") {
          parts.push(
            this.$t("bookingsHc.rerservationModal.freeUnits", {
              count: info.available_units,
            })
          );
        }
        if (Array.isArray(info.conflicts) && info.conflicts.length) {
          parts.push(info.conflicts.join(" "));
        }
        return parts.length
          ? this.$t("bookingsHc.rerservationModal.noAvailabilityDetailed", {
              details: parts.join(" "),
            })
          : this.$t("bookingsHc.rerservationModal.noAvailability");
      }
      return null;
    },

    disableCreateBtn() {
      if (
        this.isHotel &&
        this.availabilityInfo &&
        this.availabilityInfo.available === false
      ) {
        return true;
      }
      return false;
    },

    staySummaryText() {
      if (!this.startDate || !this.endDate || this.nightsSelected <= 0) return null;

      const nightsLabel =
        this.nightsSelected === 1
          ? this.$t("bookingsHc.rerservationModal.night")
          : this.$t("bookingsHc.rerservationModal.nights");
      return `${this.nightsSelected} ${nightsLabel}`;
    },

    totalEstimated() {
      return this.total || this.price || 0;
    },

    /** Los alojamientos de esta reserva: el principal y los añadidos. */
    unidadesDeLaReserva() {
      const principal = { property_id: Number(this.selectedProperty) || null, guests: Math.max(1, Number(this.number_of_guests) || 1) };
      return [principal, ...this.unidadesExtra].filter((u) => !!u.property_id);
    },
    hayVariasUnidades() {
      return this.unidadesExtra.length > 0;
    },
    /**
     * ¿Se puede repartir esta reserva en varios alojamientos? Solo en un anuncio de
     * varios apartamentos, y solo al CREAR: mover una reserva ya creada a otro
     * alojamiento es otra operación (se hace desde su ficha).
     */
    puedeVariasUnidades() {
      return !this.isHotel && !this.isEditing && this.hermanosDelAlojamiento.length > 1;
    },
    /** Los alojamientos del mismo anuncio que el principal, para poder añadirlos. */
    hermanosDelAlojamiento() {
      const principal = (this.properties || []).find((p) => Number(p.id) === Number(this.selectedProperty));
      const anuncio = principal && principal.listing_id ? Number(principal.listing_id) : null;
      if (!anuncio) return [];

      return this.formattedProperties.filter((p) => Number(p.listing_id) === anuncio);
    },
    /** Los que todavía no están en la reserva, para el desplegable de «añadir». */
    hermanosLibres() {
      const puestos = this.unidadesDeLaReserva.map((u) => Number(u.property_id));
      return this.hermanosDelAlojamiento.filter((p) => !puestos.includes(Number(p.id)));
    },
    hayDesglose() {
      return !this.isHotel && this.cotizaciones.some((l) => l && l.ok && l.quote);
    },
    /** El desglose de la primera línea: lo que se enseña cuando hay un solo alojamiento. */
    desglose() {
      const linea = this.cotizaciones[0];
      return linea && linea.quote ? linea.quote : null;
    },
    /** Total de la reserva entera, con lo que el operador ha dejado puesto. */
    totalCotizado() {
      return this.redondear(
        this.cotizaciones.reduce((suma, linea) => suma + this.totalDeLinea(linea), 0)
      );
    },
    /** ¿Hay algo configurado que se pueda cobrar aparte? Si no, no se enseña nada. */
    hayOpcionales() {
      return this.hayDesglose && this.cotizaciones.some((linea) => this.hayOpcionalesEn(linea));
    },

    /** ¿El precio escrito es el del desglose? Solo entonces se guarda el desglose. */
    precioCuadraConElDesglose() {
      return this.hayDesglose && Math.abs(Number(this.price || 0) - this.totalCotizado) < 0.01;
    },

    showStaySummaryCard() {
      return !!this.startDate && !!this.endDate && this.nightsSelected > 0;
    },

    currencyCode() {
      return this.template?.currency || this.currency || "EUR";
    },

    currencySymbol() {
      const map = {
        EUR: "€", USD: "$", COP: "$", MXN: "$", ARS: "$", CLP: "$",
        GBP: "£", BRL: "R$", PEN: "S/", JPY: "¥", CHF: "CHF",
      };
      return map[this.currencyCode] || this.currencyCode;
    },

    // Opción (objeto) seleccionada para el selector con buscador (vue-multiselect).
    selectedPropertyOption() {
      const list = this.opcionesDeAlojamiento;
      return (
        list.find((o) => Number(o.id) === Number(this.selectedProperty)) || null
      );
    },
  },

  watch: {
    bookingToEdit: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return;

        this.isEditing = true;
        this.bookingId = newVal.id;
        // Canales OTA reales: 1=Booking.com, 2=Airbnb, 3=VRBO, 4=Expedia.
        // iCal (id_channel=5) y reservas directas (null) son editables.
        const OTA_CHANNEL_IDS = [1, 2, 3, 4];
        this.isOtaBooking = !!(newVal.ota_name || OTA_CHANNEL_IDS.includes(Number(newVal.id_channel)));
        // `external_revision_id` solo lo pone el webhook de Channex: con él, la reserva vive
        // en el canal. Si la API no lo mandara, se queda en false y solo se ofrecen los
        // hermanos del anuncio, que es lo de siempre.
        this.viveEnChannex = !!(newVal.external_id && newVal.external_revision_id);

        this.name = newVal.nombre || "";
        this.email = newVal.email || "";
        this.phone = newVal.telefono || "";
        this.number_of_guests = newVal.cantidad_huesped || 1;
        const resolvedPrice = this.resolveReservationDisplayPrice(newVal);
        this.price = resolvedPrice;

        this.selectedProperty = Number(newVal.propiedad_id);
        this.startDate = (newVal.fecha_ingreso || "").split("T")[0];
        this.endDate = (newVal.fecha_salida || "").split("T")[0];
        this.originalStartDate = this.startDate;
        this.originalEndDate = this.endDate;
        this.originalPropertyId = this.selectedProperty;
        this.originalPrice = resolvedPrice;

        this._scheduleRecalc(50);
      },
    },

    selectedPropertyGlobal: {
      immediate: true,
      deep: true,
      handler(v) {
        if (this.isEditing) return;
        if (!v) return;
        const id = Number(v);
        if (!id || id === this.selectedProperty) return;

        this.selectedProperty = id;
        this._scheduleRecalc(50);
      },
    },

    selectedRange: {
      immediate: true,
      deep: true,
      handler(range) {
        this.applySelectedRangePrefill(range);
      },
    },

    selectedProperty() {
      this._updatePhoneCountry();
      this._scheduleRecalc(50);
    },

    startDate() {
      if (this.endDate && this.startDate && this.endDate <= this.startDate) {
        this.endDate = this.minEndDate;
      }
      this._scheduleRecalc(150);
    },

    endDate() {
      this._scheduleRecalc(150);
    },

    quantity() {
      this._scheduleRecalc(150);
    },

    /* Cuántos son cambia lo que se cobra: un cargo «por persona» se multiplica por
       ellos y el recargo por huésped extra aparece al pasar de la ocupación incluida.
       Sin volver a cotizar, el desglose se quedaba con el número de antes —y el
       operador veía un importe de una persona con seis en la ficha—. */
    number_of_guests() {
      this._scheduleRecalc(250);
    },


    price: {
      handler(newVal) {
        this.subtotal = newVal || 0;
        this.calculateTotal();
      },
    },

    promotions: {
      handler() {
        this.calculateTotal();
      },
      deep: true,
    },

    taxes: {
      handler() {
        this.calculateTotal();
      },
      deep: true,
    },

    isModalVisible(val) {
      if (!val) {
        this.resetForm();
        this.$store.commit("CLEAR_BOOKING_TO_EDIT");
      }
    },
  },

  methods: {
    applySelectedRangePrefill(range) {
      if (!range || this.isEditing) return;

      if (range.propertyId) {
        this.selectedProperty = Number(range.propertyId);
      }

      if (range.start && range.end) {
        this.startDate = this.toDateInput(range.start);
        this.endDate = this.toDateInput(range.end);
      }

      if (range.phone) {
        this.phone = String(range.phone || "");
      }
    },

    toDateInput(value) {
      if (!value) return null;

      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value;
      }

      const d = new Date(value);
      if (isNaN(d.getTime())) return null;

      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    parseLocalYMD(ymd) {
      if (!ymd) return null;
      return new Date(`${ymd}T00:00:00`);
    },

    formatHumanDate(ymd) {
      if (!ymd) return "—";
      const d = this.parseLocalYMD(ymd);
      if (!d || isNaN(d.getTime())) return "—";

      return d.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

    formatMoney(amount, currency = null) {
      // Los extras, la limpieza y los cargos se siguen viendo (QUÉ lleva la reserva),
      // pero sin su importe.
      if (this.ocultaImportes) return "";
      const value = Number(amount || 0);
      const finalCurrency = currency || this.template?.currency || "EUR";

      try {
        return new Intl.NumberFormat("es-ES", { useGrouping: "always",
          style: "currency",
          currency: finalCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(value);
      } catch (_) {
        return `${value} ${finalCurrency}`;
      }
    },

    normalizeMoneyValue(value) {
      if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
      }

      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return 0;

        const normalized = trimmed
          .replace(/\s/g, "")
          .replace(/\.(?=\d{3}(?:\D|$))/g, "")
          .replace(",", ".");

        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : 0;
      }

      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },

    getReservationFinancialLinesTotal(lines = []) {
      if (!Array.isArray(lines) || !lines.length) return 0;

      return lines
        .filter((line) => !Boolean(line?.is_included))
        .reduce(
          (sum, line) => sum + this.normalizeMoneyValue(line?.amount),
          0
        );
    },

    resolveReservationDisplayPrice(booking) {
      const financialLines = Array.isArray(booking?.reservation_financial_lines)
        ? booking.reservation_financial_lines
        : [];

      const breakdownTotal =
        this.getReservationFinancialLinesTotal(financialLines);

      if (breakdownTotal > 0) {
        return breakdownTotal;
      }

      const fallbackPrice =
        booking?.price ?? booking?.precio_total ?? booking?.total_cost ?? 0;

      return this.normalizeMoneyValue(fallbackPrice);
    },

    _safeSetFromStore() {
      const val = this.selectedPropertyGlobal;
      if (val) this.selectedProperty = Number(val);
      this._detectPropertyType();
      this._updatePhoneCountry();
    },

    _detectPropertyType() {
      const prop = (this.properties || []).find(
        (p) => p.id == Number(this.selectedProperty)
      );
      if (!prop) return;
      // Este modal es solo para apartamentos (no recibe roomTypes); mantenemos
      // isHotel en false y los hoteles se abren con HotelReservationModal.
      this.isHotel = false;
      this._ensureTemplateLoaded(prop.id);
    },

    // Una propiedad es HOTEL si tiene unidades tipo habitación ('room'); respaldo
    // por el tipo declarado. (`tipo_propiedad` no existe en el payload del store,
    // el campo real es `type` y las unidades vienen en `accommodationUnits`.)
    isHotelProperty(prop) {
      const units = prop?.accommodationUnits || prop?.accommodation_units || [];
      if (units.some((u) => String(u?.type || "").toLowerCase() === "room")) {
        return true;
      }
      return String(prop?.type || "").toLowerCase() === "hotel";
    },

    _updatePhoneCountry() {
      const prop = (this.properties || []).find(
        (p) => p.id == Number(this.selectedProperty)
      );

      if (prop && prop.code_pais) {
        this.defaultCountryCode = prop.code_pais.toUpperCase();
      } else {
        this.defaultCountryCode = "ES";
      }
    },

    async _ensureTemplateLoaded(id) {
      if (!id) return;

      if (this.templateCache[id]) {
        this.template = this.templateCache[id];
        this.selectedPropertyName = this.template?.nombre || null;
        return;
      }

      if (this.ctrl.getProperty) this.ctrl.getProperty.abort();
      this.ctrl.getProperty = new AbortController();

      try {
        const { data } = await axios.get("/get-property", {
          params: { id },
          signal: this.ctrl.getProperty.signal,
        });
        this.templateCache[id] = data;
        this.template = data;
        this.selectedPropertyName = data?.nombre || null;
      } catch (e) {
        if (e.name !== "CanceledError" && e.code !== "ERR_CANCELED") {
          this.template = {};
        }
      } finally {
        this.ctrl.getProperty = null;
      }
    },

    _scheduleRecalc(delay = 250) {
      if (this.isBooting) return;
      if (this.debounceTimer) clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(async () => {
        await this._onRecalc();
      }, delay);
    },

    async _onRecalc() {
      this._detectPropertyType();

      const ready =
        !!this.selectedProperty && !!this.startDate && !!this.endDate;
      if (!ready) {
        this.btnPriceDisable = false;
        this.priceNight = 0;
        this.availabilityInfo = null;
        this.availabilityError = null;
        this.minStayRequired = null;
        this.minStaySource = null;
        this.minStayWarning = null;
        return;
      }

      const jobs = [];

      // En un apartamento el precio sale de la cotización de la reserva directa —la
      // misma que ve el huésped en la web—, que además trae la limpieza y los cargos
      // del anfitrión. Si esa cotización no sale (sin tarifa para esas fechas), se cae
      // al cálculo de siempre, que solo sabe de noches.
      jobs.push(this.isHotel ? this._calcApartmentPrice() : this._cotizarReservaDirecta());
      jobs.push(this._fetchMinStayRules());

      if (this.isHotel) jobs.push(this._fetchHotelAvailability());

      await Promise.allSettled(jobs);
    },

    /**
     * Lo que cobraría la reserva directa por esta estancia, alojamiento por alojamiento.
     *
     * El operador crea reservas de mostrador —teléfono, WhatsApp, recepción— y hasta
     * ahora el panel le ponía solo las noches: la limpieza configurada y los cargos del
     * anfitrión se quedaban fuera, así que lo mismo valía distinto por internet que por
     * teléfono. Ahora se le enseña el desglose entero y él decide qué aplica.
     */
    async _cotizarReservaDirecta() {
      if (!this.selectedProperty || !this.startDate || !this.endDate) return;

      if (this.ctrl.calcPrice) this.ctrl.calcPrice.abort();
      this.ctrl.calcPrice = new AbortController();
      this.cotizando = true;

      try {
        const { data } = await axios.post(
          "/booking/quote-units",
          {
            start_date: this.startDate,
            end_date: this.endDate,
            units: this.unidadesDeLaReserva.map((u) => ({
              property_id: u.property_id,
              guestsDetails: { adults: Math.max(1, Number(u.guests) || 1), children: 0, infants: 0 },
            })),
          },
          { signal: this.ctrl.calcPrice.signal }
        );

        this.cotizaciones = (data && data.lines) || [];
        const primera = this.cotizaciones[0];
        this.currency = (primera && primera.currency) || this.currency;

        if (this.hayDesglose) {
          this.btnPriceDisable = true;
          this.aplicarTotalCotizado();

          return;
        }

        // Sin tarifa para esas fechas: el cálculo de siempre, para no dejarlo a ciegas.
        await this._calcApartmentPrice();
      } catch (e) {
        if (e.name === "CanceledError" || e.code === "ERR_CANCELED") return;
        console.error("Quote error:", e);
        this.cotizaciones = [];
        await this._calcApartmentPrice();
      } finally {
        this.cotizando = false;
        this.ctrl.calcPrice = null;
      }
    },

    redondear(v) {
      return Math.round((Number(v) || 0) * 100) / 100;
    },

    /** Un cargo se reconoce por su título: es lo que el anfitrión ve en su configuración. */
    claveDeCargo(cargo) {
      return String((cargo && (cargo.title || cargo.name)) || "");
    },

    /**
     * Lo que el operador ha decidido cobrar en ese alojamiento.
     *
     * De salida NO se cobra nada opcional: la limpieza y los cargos se ENSEÑAN, con su
     * importe, y se marcan uno a uno. Una reserva de mostrador no siempre los lleva —un
     * cliente de siempre, una noche suelta, un acuerdo—, y cobrar de más por una casilla
     * que venía puesta es peor que cobrar de menos por una que se olvidó.
     *
     * NO crea nada: esto se lee al pintar, y tocar el estado mientras Vue pinta es
     * pedirle que vuelva a pintar, y otra vez, y otra. La fila se crea cuando el
     * operador toca un interruptor, que es cuando existe de verdad.
     */
    opcionesDe(propertyId) {
      return this.opciones[String(propertyId)] || this.opcionesEnBlanco(propertyId);
    },

    /**
     * Todo apagado: ni se cobra ni se descuenta nada hasta que el operador lo marca.
     *
     * El descuento trae escrito el que tenga configurado el anuncio —por ocupación o
     * por promoción— pero NO se aplica solo. Aplicarlo por su cuenta era lo que hacía
     * que el calendario dijera 120 y el modal 72 sin que nadie supiera por qué.
     */
    opcionesEnBlanco(propertyId) {
      const linea = this.cotizaciones.find((l) => Number(l.property_id) === Number(propertyId));

      return {
        conLimpieza: false,
        cargos: [],
        conExtra: false,
        conDescuento: false,
        descuento: this.descuentoSugeridoDe(linea),
      };
    },

    /** La misma, pero creándola si hace falta. Solo desde los interruptores. */
    asegurarOpciones(propertyId) {
      const clave = String(propertyId);
      if (!this.opciones[clave]) this.$set(this.opciones, clave, this.opcionesEnBlanco(propertyId));
      return this.opciones[clave];
    },

    /**
     * ¿Tiene ESTE alojamiento algo opcional que marcar?
     *
     * Si no hay limpieza ni cargos configurados en su reserva directa no hay nada que
     * elegir, y una lista con una sola línea —las noches— parece rota. Se dice con
     * todas las letras y se queda claro que el sitio donde se configura es otro.
     */
    hayOpcionalesEn(linea) {
      return (
        this.limpiezaDe(linea) > 0 ||
        this.cargosDe(linea).length > 0 ||
        this.extraDe(linea) > 0 ||
        this.descuentoSugeridoDe(linea) > 0
      );
    },

    limpiezaDe(linea) {
      const importe = Number((linea && linea.quote && linea.quote.cleaning_fee && linea.quote.cleaning_fee.amount) || 0);
      return importe > 0 ? importe : 0;
    },

    /** El recargo por los huéspedes que pasan de la ocupación incluida del anuncio. */
    extraDe(linea) {
      const importe = Number((linea && linea.quote && linea.quote.extra_guest && linea.quote.extra_guest.fee_total) || 0);
      return importe > 0 ? importe : 0;
    },

    huespedesExtraDe(linea) {
      return Number((linea && linea.quote && linea.quote.extra_guest && linea.quote.extra_guest.extra_guests) || 0);
    },

    /** Lo que la web le descontaría a ese huésped. Se PROPONE; aplicarlo es decisión suya. */
    descuentoSugeridoDe(linea) {
      const importe = Number((linea && linea.quote && linea.quote.discount_total) || 0);
      return importe > 0 ? this.redondear(importe) : 0;
    },

    /** ¿El descuento propuesto viene de la regla de ocupación del anuncio? */
    descuentoEsPorOcupacion(linea) {
      return Number((linea && linea.quote && linea.quote.occupancy_discount && linea.quote.occupancy_discount.amount) || 0) > 0;
    },

    cargosDe(linea) {
      return (linea && linea.quote && linea.quote.additional_charges) || [];
    },

    /**
     * El total de una línea: las noches MÁS lo que el operador haya marcado.
     *
     * Se suma desde las noches en vez de restar de un total ya compuesto para que el
     * precio de partida sea exactamente el que enseña el calendario. Cada cosa que se
     * marca se ve subir, y el descuento se ve bajar; no hay nada que explicar.
     *
     * No se vuelve a pedir la cotización al servidor: ya dijo cuánto vale cada cosa, y
     * esperar por tocar un interruptor no aporta nada.
     */
    totalDeLinea(linea) {
      if (!linea || !linea.quote) return 0;

      const aMano = this.preciosAMano[String(linea.property_id)];
      if (aMano !== undefined && aMano !== null && aMano !== "") return this.redondear(aMano);

      const opciones = this.opcionesDe(linea.property_id);
      let total = Number(linea.quote.base_subtotal || 0);

      if (opciones.conExtra) total += this.extraDe(linea);
      if (opciones.conLimpieza) total += this.limpiezaDe(linea);

      this.cargosDe(linea).forEach((cargo) => {
        if (opciones.cargos.includes(this.claveDeCargo(cargo))) total += Number(cargo.amount || 0);
      });

      if (opciones.conDescuento) total -= this.descuentoDe(linea);

      return this.redondear(Math.max(0, total));
    },

    /** El descuento que se va a aplicar de verdad: 0 si no está marcado. */
    descuentoDe(linea) {
      const opciones = this.opcionesDe(linea.property_id);
      if (!opciones.conDescuento) return 0;
      return Math.max(0, this.redondear(opciones.descuento));
    },

    /**
     * Encender o apagar «Otras opciones».
     *
     * Al apagarlo se quita TODO lo marcado: es la salida rápida —«esta reserva no lleva
     * extras»— y dejar casillas marcadas dentro de algo apagado sería mentir sobre lo
     * que se va a cobrar.
     */
    alternarOtrasOpciones() {
      this.otrasOpciones = !this.otrasOpciones;

      if (!this.otrasOpciones) {
        this.cotizaciones.forEach((linea) => {
          this.$set(this.opciones, String(linea.property_id), this.opcionesEnBlanco(linea.property_id));
        });
        this.aplicarTotalCotizado(true);
      }
    },

    alternarLimpieza(linea) {
      const opciones = this.asegurarOpciones(linea.property_id);
      this.$set(opciones, "conLimpieza", !opciones.conLimpieza);
      this.aplicarTotalCotizado(true);
    },

    alternarExtra(linea) {
      const opciones = this.asegurarOpciones(linea.property_id);
      this.$set(opciones, "conExtra", !opciones.conExtra);
      this.aplicarTotalCotizado(true);
    },

    alternarDescuento(linea) {
      const opciones = this.asegurarOpciones(linea.property_id);
      this.$set(opciones, "conDescuento", !opciones.conDescuento);
      if (opciones.conDescuento && !(Number(opciones.descuento) > 0)) {
        this.$set(opciones, "descuento", this.descuentoSugeridoDe(linea));
      }
      this.aplicarTotalCotizado(true);
    },

    /**
     * El importe del descuento lo escribe el operador. Escribir uno lo da por aplicado:
     * teclear 30 y que no pasara nada hasta marcar además la casilla sería una trampa.
     *
     * Se guarda TAL CUAL se teclea, sin convertirlo a número: convertir un campo vacío
     * en 0 y devolvérselo escrito impide borrarlo para escribir otra cifra. Lo que
     * vale lo decide `descuentoDe`, que ya sabe leer un campo vacío como «nada».
     */
    escribirDescuento(linea, valor) {
      const opciones = this.asegurarOpciones(linea.property_id);
      this.$set(opciones, "descuento", Number(valor) < 0 ? 0 : valor);
      if (!opciones.conDescuento) this.$set(opciones, "conDescuento", true);
      this.aplicarTotalCotizado(true);
    },

    alternarCargo(linea, cargo) {
      const opciones = this.asegurarOpciones(linea.property_id);
      const clave = this.claveDeCargo(cargo);
      const i = opciones.cargos.indexOf(clave);
      if (i === -1) opciones.cargos.push(clave);
      else opciones.cargos.splice(i, 1);
      this.aplicarTotalCotizado(true);
    },

    escribirPrecioDeLinea(linea, valor) {
      const limpio = valor === "" || valor === null ? null : Math.max(0, Number(valor) || 0);
      this.$set(this.preciosAMano, String(linea.property_id), limpio);
      this.aplicarTotalCotizado();
    },

    /**
     * Lleva el total al precio.
     *
     * Un precio escrito a mano no se pisa con un recálculo cualquiera —el operador
     * manda—, PERO marcar o desmarcar una opción sí lo actualiza: acaba de decir que
     * cobra una cosa más, y dejar el importe viejo sería cobrar lo que él ya no quiere.
     * De ahí el `forzar`.
     */
    aplicarTotalCotizado(forzar = false) {
      if (!forzar && this.precioAMano && !this.hayVariasUnidades) return;
      if (!this.shouldAutoRecalculatePrice()) return;

      this.price = this.totalCotizado;
      if (forzar) this.precioAMano = false;
    },

    /** Añade otro alojamiento del mismo anuncio a esta reserva. */
    anadirUnidad(propertyId) {
      if (!propertyId) return;
      this.unidadesExtra.push({ property_id: Number(propertyId), guests: 1 });
      this._scheduleRecalc(50);
    },

    /** Un huésped más o uno menos en ese alojamiento; nunca por debajo de uno. */
    cambiarHuespedesDeUnidad(indice, delta) {
      const extra = this.unidadesExtra[indice];
      if (!extra) return;

      this.$set(extra, "guests", Math.max(1, (Number(extra.guests) || 1) + delta));
      this._scheduleRecalc(150);
    },

    quitarUnidad(indice) {
      const fuera = this.unidadesExtra.splice(indice, 1)[0];
      if (fuera) {
        this.$delete(this.opciones, String(fuera.property_id));
        this.$delete(this.preciosAMano, String(fuera.property_id));
      }
      this._scheduleRecalc(50);
    },

    nombreDeAlojamiento(propertyId) {
      const p = (this.properties || []).find((x) => Number(x.id) === Number(propertyId));
      if (!p) return "";
      return p.internalName ? `${p.internalName} - ${p.nombre}` : p.nombre;
    },

    /**
     * El desglose que se guarda con cada línea, ya sin lo que el operador quitó, para
     * que la factura y el recibo digan exactamente lo que se cobró. Si escribió un
     * precio distinto, NO se guarda ninguno: un desglose que no suma lo cobrado engaña
     * más que no tener desglose.
     */
    desgloseParaGuardar() {
      const linea = this.cotizaciones[0];
      if (!linea || !linea.quote || !this.precioCuadraConElDesglose) return null;

      return this.quoteAjustada(linea);
    },

    quoteAjustada(linea) {
      const q = JSON.parse(JSON.stringify(linea.quote));
      const opciones = this.opcionesDe(linea.property_id);

      if (!opciones.conLimpieza && q.cleaning_fee) {
        q.cleaning_fee.amount = 0;
        q.cleaning_fee.enabled = false;
      }

      if (!opciones.conExtra && q.extra_guest) {
        q.extra_guest.fee_total = 0;
        q.extra_guest.fee = 0;
      }

      if (Array.isArray(q.additional_charges)) {
        q.additional_charges = q.additional_charges.filter(
          (cargo) => opciones.cargos.includes(this.claveDeCargo(cargo))
        );
        q.additional_charges_total = q.additional_charges.reduce((suma, c) => suma + Number(c.amount || 0), 0);
      }

      // El descuento del desglose es el que se cobró, no el que proponía la web. Si el
      // operador cambió el importe, la promoción con nombre deja de valer y se guarda
      // una línea de descuento a secas: que la factura diga la verdad manda sobre que
      // diga algo bonito.
      const descuento = this.descuentoDe(linea);
      const suPropuesta = descuento > 0 && Math.abs(descuento - this.descuentoSugeridoDe(linea)) < 0.01;

      q.discount_total = descuento;
      if (!suPropuesta) {
        q.promotions_applied = [];
        if (q.occupancy_discount) {
          q.occupancy_discount.amount = 0;
          q.occupancy_discount.percent = 0;
        }
      }

      q.total = this.totalDeLinea(linea);

      return q;
    },

    /** Lo que se manda al crear una reserva repartida en varios alojamientos. */
    unidadesParaGuardar() {
      return this.unidadesDeLaReserva.map((u) => {
        const opciones = this.opcionesDe(u.property_id);
        const aMano = this.preciosAMano[String(u.property_id)];
        const linea = this.cotizaciones.find((l) => Number(l.property_id) === Number(u.property_id));

        return {
          property_id: u.property_id,
          guestsDetails: { adults: Math.max(1, Number(u.guests) || 1), children: 0, infants: 0 },
          sin_limpieza: !opciones.conLimpieza,
          sin_extra: !opciones.conExtra,
          descuento: linea ? this.descuentoDe(linea) : 0,
          cargos_fuera: this.cargosDe(linea)
            .map((cargo) => this.claveDeCargo(cargo))
            .filter((clave) => !opciones.cargos.includes(clave)),
          price: aMano !== undefined && aMano !== null && aMano !== "" ? this.redondear(aMano) : (linea ? this.totalDeLinea(linea) : null),
        };
      });
    },

    /**
     * El cálculo de siempre: SOLO las noches de la tarifa del panel.
     *
     * Es el respaldo de la cotización de la reserva directa —cuando no hay tarifa para
     * esas fechas y no sale desglose— y el camino del hotel, que tiene el suyo. Se
     * quedó fuera al reescribir este bloque y la pantalla moría con
     * «_calcApartmentPrice is not a function» justo cuando más falta hacía: sin
     * cotización, el precio se quedaba a cero y no se veía por qué.
     */
    async _calcApartmentPrice() {
      if (!this.selectedProperty || !this.startDate || !this.endDate) return;
      if (!this.shouldAutoRecalculatePrice()) {
        this.btnPriceDisable = false;
        this.priceNight = 0;
        return;
      }
      if (this.ctrl.calcPrice) this.ctrl.calcPrice.abort();
      this.ctrl.calcPrice = new AbortController();

      try {
        const { data } = await axios.post(
          "/calculate-apartment-price",
          {
            start_date: this.startDate,
            end_date: this.endDate,
            property_id: this.selectedProperty,
          },
          { signal: this.ctrl.calcPrice.signal }
        );

        this.price = data?.total_price ?? 0;
        this.priceNight = data?.price_per_night ?? 0;
        this.currency = data?.currency || this.template?.currency || "EUR";
        this.btnPriceDisable = true;
      } catch (e) {
        if (e.name === "CanceledError" || e.code === "ERR_CANCELED") return;
        console.error("Price calc error:", e);
        this.btnPriceDisable = false;
      } finally {
        this.ctrl.calcPrice = null;
      }
    },

    async _fetchHotelAvailability() {
      this.availabilityError = null;

      if (this.ctrl.hotelAvail) this.ctrl.hotelAvail.abort();
      this.ctrl.hotelAvail = new AbortController();

      try {
        const payload = {
          start_date: this.startDate,
          end_date: this.endDate,
          quantity: this.quantity || 1,
          accommodation_type: { id: this.selectedProperty },
          booking_id: this.isEditing ? this.bookingId : null,
        };

        const { data } = await axios.post("/hotel-availability", payload, {
          signal: this.ctrl.hotelAvail.signal,
        });

        this.availabilityInfo = {
          available: !!data?.available,
          available_units: data?.available_units,
          conflicts: data?.conflicts || [],
        };
      } catch (err) {
        if (err.name === "CanceledError" || err.code === "ERR_CANCELED") return;

        const msg =
          err?.response?.data?.error ||
          this.$t("bookingsHc.rerservationModal.hotelAvailabilityError");

        this.availabilityError = msg;
        this.availabilityInfo = {
          available: false,
          available_units: 0,
          conflicts: [],
        };
      } finally {
        this.ctrl.hotelAvail = null;
      }
    },

    async _fetchMinStayRules() {
      if (!this.selectedProperty || !this.startDate || !this.endDate) return;

      this.minStayRequired = null;
      this.minStaySource = null;
      this.minStayWarning = null;

      if (this.ctrl.minStay) this.ctrl.minStay.abort();
      this.ctrl.minStay = new AbortController();

      try {
        const { data } = await axios.post(
          "/apartment/availability-minstay",
          {
            property_id: this.selectedProperty,
            start_date: this.startDate,
            booking_id: this.isEditing ? this.bookingId : null,
            end_date: this.endDate,
          },
          { signal: this.ctrl.minStay.signal }
        );

        if (typeof data?.available !== "undefined") {
          this.availabilityInfo = {
            available: !!data.available,
            conflicts: data.conflicts || [],
          };
        }

        let arrivalMin = null;

        if (
          data?.effective_min_stay &&
          typeof data.effective_min_stay === "object"
        ) {
          const v = data.effective_min_stay[this.startDate];
          arrivalMin = v != null && Number(v) > 0 ? Number(v) : null;
        } else if (typeof data?.min_nights !== "undefined") {
          arrivalMin =
            Number(data.min_nights) > 0 ? Number(data.min_nights) : null;
        }

        this.minStayRequired = arrivalMin;
        this.minStaySource = arrivalMin ? "rate_price" : null;

        if (
          this.minStayRequired &&
          this.nightsSelected > 0 &&
          this.nightsSelected < this.minStayRequired
        ) {
          this.minStayWarning = this.$t("bookingsHc.rerservationModal.minStayWarning", {
            count: this.minStayRequired,
            selected: this.nightsSelected,
          });
        }
      } catch (err) {
        if (err.name === "CanceledError" || err.code === "ERR_CANCELED") return;

        this.minStayRequired = null;
        this.minStaySource = null;
        this.minStayWarning = null;

        const vErr = err?.response?.data?.errors;
        if (vErr?.end_date || vErr?.start_date) {
          const msg =
            vErr?.end_date?.[0] ||
            vErr?.start_date?.[0] ||
            "Error de validación en min stay.";
          console.warn(msg);
        }
      } finally {
        this.ctrl.minStay = null;
      }
    },

    /**
     * Buscar cliente: se abre con el botón del campo, nunca al escribir. Escribiendo solo
     * se pone el nombre: las sugerencias sobre la marcha hacían elegir a quien no era.
     */
    toggleGuestPicker() {
      if (this.showGuestSuggestions) {
        this.showGuestSuggestions = false;
        return;
      }
      this.guestPickerQuery = "";
      this.showGuestSuggestions = true;
      this.searchGuests();
      this.$nextTick(() => {
        if (this.$refs.guestPickerInput) this.$refs.guestPickerInput.focus();
      });
    },

    searchGuests() {
      if (this.guestSearchDebounce) clearTimeout(this.guestSearchDebounce);
      const text = (this.guestPickerQuery || "").trim();

      this.guestSearchDebounce = setTimeout(async () => {
        this.guestSearchLoading = true;

        try {
          // Sin texto, los últimos clientes; con texto, los que coincidan.
          const items = text.length >= 2
            ? await buscarClientes(text)
            : (await listarClientes({ perPage: 20 })).data || [];

          if ((this.guestPickerQuery || "").trim() !== text) return;

          this.guestSuggestions = items.map((c) => ({
            id: c.id,
            label: c.nombre_completo,
            nombre: c.nombre,
            apellido: c.apellido,
            email: c.email,
            whatsapp: c.telefono,
            documento: c.nu_documento,
          }));
        } catch (e) {
          console.error("Guest search error:", e);
          this.guestSuggestions = [];
        } finally {
          this.guestSearchLoading = false;
        }
      }, text ? 250 : 0);
    },

    applyGuestSuggestion(guest) {
      this.selectedGuestSuggestionId = guest.id;

      this.name = [guest.nombre, guest.apellido].filter(Boolean).join(" ").trim();

      this.email = guest.email || "";
      this.phone = guest.whatsapp || "";

      if (guest.pais_code && String(guest.pais_code).length === 2) {
        this.defaultCountryCode = String(guest.pais_code).toUpperCase();
      }

      this.guestSuggestions = [];
      this.showGuestSuggestions = false;
    },

    handleOutsideGuestSuggestions(event) {
      if (!this.$refs.guestAutocompleteWrap) return;
      if (!this.$refs.guestAutocompleteWrap.contains(event.target)) {
        this.showGuestSuggestions = false;
      }
    },

    clearSelectedGuest() {
      this.selectedGuestSuggestionId = null;
    },

    checkMaxGuests() {},

    checkQuantity() {
      if (this.btnPriceDisable && this.quantity > 1) {
        this.price = (this.priceNight || 0) * this.quantity;
      } else {
        this.price = this.priceNight || 0;
      }
    },

    calculateTotal() {
      const subtotal = this.subtotal || 0;
      const totalPromotions = this.promotions.reduce(
        (acc, p) => acc + (p.price || 0),
        0
      );
      const totalTaxes = this.taxes.reduce((acc, t) => acc + (t.price || 0), 0);
      this.total = subtotal - totalPromotions + totalTaxes;
    },

    shouldAutoRecalculatePrice() {
      // Reserva nueva → siempre recalcular
      if (!this.isEditing) return true;

      // Reserva no-OTA (iCal, directa) sin precio asignado → recalcular al abrir
      // para que el modal muestre el precio sugerido en vez de 0
      if (!this.isOtaBooking && !this.originalPrice) return true;

      // Reserva existente con precio → recalcular solo si cambiaron fechas o propiedad
      return (
        Number(this.selectedProperty) !== Number(this.originalPropertyId) ||
        this.startDate !== this.originalStartDate ||
        this.endDate !== this.originalEndDate
      );
    },

    async saveReservation() {
  if (this.isSubmitting) return;

  if (!this.validateForm()) return;

  this.isSubmitting = true;
  this.Loader = true;

  try {
    if (this.isEditing && this.isOtaBooking) {
      this.startDate = this.originalStartDate;
      this.endDate = this.originalEndDate;
    }

    if (this.isHotel) {
      if (!this.availabilityInfo && !this.availabilityError) {
        await this._fetchHotelAvailability();
      }
      if (this.availabilityError) {
        $toast.error(this.availabilityError);
        return;
      }
      if (
        this.availabilityInfo &&
        this.availabilityInfo.available === false
      ) {
        const u = this.availabilityInfo.available_units ?? 0;
        $toast.warning(
          this.$t("bookingsHc.rerservationModal.notEnoughAvailability", { count: u })
        );
        return;
      }
    } else {
      if (
        this.availabilityInfo &&
        this.availabilityInfo.available === false
      ) {
        $toast.warning(this.$t("bookingsHc.rerservationModal.noAvailabilityDates"));
        return;
      }
    }

    if (!this.minStayRequired) {
      await this._fetchMinStayRules();
    }

    const reservation = {
      id: this.isEditing ? this.bookingId : null,
      start: this.startDate,
      end: this.endDate,
      start_date: this.startDate,
      end_date: this.endDate,
      name: this.name,
      email: this.email,
      phone: (this.phone || "").replace(/\s/g, ""),
      number_of_guests: this.number_of_guests,
      price:
        this.isEditing && this.isOtaBooking
          ? this.originalPrice
          : this.total || this.price,
      propertyId: this.selectedProperty,
      propertyTitle: this.selectedPropertyName,
      user_id: this.user?.id || null,
      originalStart: this.originalStartDate,
      originalEnd: this.originalEndDate,
      originalPropertyId: this.originalPropertyId,
      original_start_date: this.originalStartDate,
      original_end_date: this.originalEndDate,
      original_property_id: this.originalPropertyId,
      quantity: this.quantity,
      promotions: this.promotions,
      taxes: this.taxes,
      resend_confirmation: this.isEditing && this.resendConfirmation,
      guest_id: this.selectedGuestSuggestionId,
      // Cliente del directorio elegido en el autocompletado: la reserva queda en su ficha.
      directorio_cliente_id: this.isEditing ? null : this.selectedGuestSuggestionId,
      // El desglose de la reserva directa, cuando el precio es el suyo: así el recibo y
      // la factura enseñan las noches, la limpieza y los cargos por separado.
      quote_data: this.isEditing ? null : this.desgloseParaGuardar(),
      crm_chat_id: this.selectedRange?.crm_chat_id || null,
      crm_waba_phone_number_id: this.selectedRange?.crm_waba_phone_number_id || null,
    };

    const success = this.isEditing
      ? await this.handleUpdateReservation(reservation)
      : this.hayVariasUnidades
        ? await this.crearReservaDeVariasUnidades()
        : await this.handleSaveReservation(reservation, {
            start: this.startDate,
            end: this.endDate,
          });

    if (success) {
      this.resetForm();
      this.$store.commit("CLEAR_BOOKING_TO_EDIT");
    }
  } finally {
    this.Loader = false;
    this.isSubmitting = false;
  }
},


    /**
     * Una sola reserva repartida en varios alojamientos del anuncio. El precio de cada
     * uno viaja por separado —es lo que se ha visto en el desglose— y el servidor vuelve
     * a comprobar que todos sean del mismo anuncio y estén libres.
     */
    async crearReservaDeVariasUnidades() {
      try {
        const { data } = await axios.post("/create/units-group", {
          start_date: this.startDate,
          end_date: this.endDate,
          name: this.name,
          email: this.email || null,
          phone: (this.phone || "").replace(/\s/g, ""),
          units: this.unidadesParaGuardar(),
        });

        this.$root.$emit("booking-created", data);
        this.getProperty(this.selectedProperty);
        $toast.success(this.$t("empresa.reservas.p152"));
        return true;
      } catch (error) {
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          this.$t("bookingsHc.rerservationModal.unitsGroupError");
        $toast.error(msg);
        return false;
      }
    },

    clearError(field) {
      if (this.errors[field]) this.$delete(this.errors, field);
    },

    incQty() {
      const max = this.selectedRoomTypeInfo.available_instances || 1;
      if (this.quantity < max) this.quantity = (this.quantity || 1) + 1;
      this.checkQuantity();
    },

    decQty() {
      if (this.quantity > 1) this.quantity = this.quantity - 1;
      this.checkQuantity();
    },

    // El teléfono de este modal vive en `phone`, no en `form.phone` (mixin telefonoDelHuesped).
    ponerTelefono(valor) {
      this.phone = valor;
    },

    validateForm() {
      this.errors = {};
      const fail = (field, msg) => {
        this.$set(this.errors, field, true);
        $toast.warning(msg);
        return false;
      };

      if (!this.selectedProperty) {
        return fail("property", this.$t("modal.validations.selectAccommodation"));
      }
      if (!this.startDate || !this.endDate) {
        return fail("dates", this.$t("modal.validations.selectDates"));
      }
      if (this.nightsSelected <= 0) {
        return fail("dates", this.$t("bookingsHc.rerservationModal.departureAfterArrival"));
      }
      if (!this.name) {
        return fail("name", this.$t("modal.validations.fillRequired"));
      }

      const phoneDigits = (this.phone || "").replace(/\D/g, "");
      if (!this.phone || phoneDigits.length < 5) {
        return fail("phone", this.$t("modal.validations.phoneMin"));
      }
      // Prefijo de otro país (ver mixins/telefonoDelHuesped): se avisa una vez al crear.
      if (!this.isEditing && this.telefonoParaRevisar()) {
        this.errors = { ...this.errors, phone: true };
        return false;
      }

      if (this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        return fail("email", this.$t("modal.validations.invalidEmail"));
      }

      if (this.number_of_guests < 1) {
        return fail("guests", this.$t("modal.validations.guestsMin"));
      }

      if (this.price < 0) {
        return fail("price", this.$t("modal.validations.priceNegative"));
      }

      return true;
    },

    retrieveNameProperty() {
      const prop = (this.properties || []).find(
        (p) => p.id == Number(this.selectedProperty)
      );
      this.selectedPropertyName = prop ? prop.nombre : "";
    },

    toggleModal(value) {
      this.$store.commit("SET_MODAL_BOOKING_VISIBILITY", value);
    },

    openReservationModal() {
      this.showModal = true;
    },

    resetForm() {
      Object.values(this.ctrl).forEach((c) => {
        try {
          c?.abort?.();
        } catch (_) {}
      });

      this.name = "";
      this.surname = "";
      this.startDate = null;
      this.endDate = null;
      this.email = "";
      this.phone = "";
      this.number_of_guests = 1;
      this.price = 0;
      this.resendConfirmation = false;
      this.selectedProperty = null;
      this.isEditing = false;

      this.bookingId = null;
      this.promotions = [];
      this.taxes = [];
      this.total = 0;
      this.subtotal = 0;
      this.cotizaciones = [];
      this.opciones = {};
      this.unidadesExtra = [];
      this.preciosAMano = {};
      this.precioAMano = false;
      this.otrasOpciones = false;
      this.originalStartDate = null;
      this.originalEndDate = null;
      this.originalPropertyId = null;
      this.originalPrice = 0;

      this.availabilityInfo = null;
      this.availabilityError = null;
      this.minStayRequired = null;
      this.minStaySource = null;
      this.minStayWarning = null;
      this.isOtaBooking = false;
      this.viveEnChannex = false;
      this.defaultCountryCode = "ES";
      this.priceNight = 0;
      this.quantity = 1;

      this.guestSuggestions = [];
      this.showGuestSuggestions = false;
      this.selectedGuestSuggestionId = null;
      this.guestSearchLoading = false;

      this.$store.commit("SET_SELECTED_BOOKING_RANGE", null);
      this.$store.commit("SET_PROPERTY_SELECT", null);
      this.$store.commit("SET_MODAL_BOOKING_VISIBILITY", false);
      this.$store.commit("CLEAR_BOOKING_TO_EDIT");
    },

    onHide() {
      this.resetForm();
      this.$store.commit("CLEAR_BOOKING_TO_EDIT");
    },

    onUpdateVisible(value) {
      this.$store.commit("SET_MODAL_BOOKING_VISIBILITY", value);
      if (!value) {
        this.resetForm();
      }
    },
  },
};
</script>

<template>
  <transition name="rm-pop" appear>
    <div
      v-if="isModalVisible"
      class="rm-overlay"
      @mousedown.self="onUpdateVisible(false)"
    >
      <div
        class="rm-dialog"
        :class="{ 'rm-dialog--mobile': $isMobile }"
        role="dialog"
        aria-modal="true"
      >
        <LoaderModal :message="$t('modal.processing')" v-if="Loader" />

        <!-- Header -->
        <header class="rm-head">
          <div class="rm-head__icon"><i class="fal fa-calendar-plus"></i></div>
          <div class="rm-head__tx">
            <h2 class="rm-head__title">{{ modalTitle }}</h2>
            <p v-if="selectedPropertyName" class="rm-head__sub">
              {{ selectedPropertyName }}
            </p>
          </div>
          <button
            type="button"
            class="rm-head__close"
            @click="onUpdateVisible(false)"
            :aria-label="$t('bookingsHc.rerservationModal.close')"
          >
            <i class="fal fa-times"></i>
          </button>
        </header>

        <!-- Body -->
        <div class="rm-body">
          <div
            v-if="availabilityBannerText"
            class="rm-alert rm-alert--danger"
            role="alert"
          >
            <i class="fas fa-exclamation-circle"></i>
            <span>{{ availabilityBannerText }}</span>
          </div>

          <div v-if="minStayBannerText" class="rm-alert rm-alert--info">
            <i class="fas fa-info-circle"></i>
            <span>{{ minStayBannerText }}</span>
          </div>

          <!-- Alojamiento / tipo de habitación (selector con buscador) -->
          <div class="rm-field">
            <label class="rm-label">
              {{ isHotel ? $t("modal.selectRoomType") : $t("modal.selectAccommodation") }}
            </label>
            <multiselect
              :value="selectedPropertyOption"
              :options="opcionesDeAlojamiento"
              :custom-label="(o) => o.displayName"
              track-by="id"
              :searchable="true"
              :show-labels="false"
              :allow-empty="false"
              :max-height="260"
              open-direction="bottom"
              class="rm-ms"
              :class="{ 'rm-ms--err': errors.property }"
              :disabled="isEditing && isOtaBooking && !puedeMudarseDeAlojamiento"
              :placeholder="isHotel ? $t('modal.selectRoomType') : $t('modal.selectAccommodation')"
              @input="(o) => { if (o) { selectedProperty = o.id; clearError('property'); } }"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <i class="fal fa-home rm-ms__ic"></i> {{ option.displayName }}
              </template>
              <template slot="option" slot-scope="{ option }">
                <i class="fal fa-home rm-ms__ic"></i> {{ option.displayName }}
              </template>
              <template slot="noResult"><span class="rm-ms__nores">{{ $t("bookingsHc.rerservationModal.noMatches") }}</span></template>
              <template slot="noOptions"><span class="rm-ms__nores">{{ $t("bookingsHc.rerservationModal.noAccommodations") }}</span></template>
            </multiselect>

            <!-- Lo único que se le puede cambiar a una reserva del canal: decirlo evita
                 que el anfitrión piense que el resto también se ha desbloqueado. -->
            <p v-if="puedeMudarseDeAlojamiento" class="rm-hint-move">
              <i class="fal fa-exchange"></i>
              {{ $t(viveEnChannex ? "bookingsHc.rerservationModal.otaMoveHintCuenta" : "bookingsHc.rerservationModal.otaMoveHint") }}
            </p>
            <!-- A otro anuncio el canal no se puede enterar: que el anfitrión lo sepa antes de guardar. -->
            <p v-if="seReubicaFueraDelAnuncio" class="rm-hint-move rm-hint-move--otro">
              <i class="fal fa-info-circle"></i>
              {{ $t("bookingsHc.rerservationModal.otaRelocateNote") }}
            </p>

            <!-- Varios alojamientos en UNA reserva, como las habitaciones de un hotel.
                 Cuatro amigos en dos estudios del mismo anuncio son una reserva, no dos:
                 un código, un check-in y un cobro. -->
            <!-- Varios alojamientos en UNA reserva, como las habitaciones de un hotel.
                 Cuatro amigos en dos estudios del mismo anuncio son una reserva, no dos:
                 un código, un check-in y un cobro. -->
            <div v-if="puedeVariasUnidades" class="rm-units">
              <transition-group name="rm-unit" tag="div" class="rm-units__list">
                <div v-for="(extra, i) in unidadesExtra" :key="extra.property_id" class="rm-unit">
                  <span class="rm-unit__ic" aria-hidden="true"><i class="fal fa-home"></i></span>

                  <span class="rm-unit__name" :title="nombreDeAlojamiento(extra.property_id)">
                    {{ nombreDeAlojamiento(extra.property_id) }}
                  </span>

                  <!-- Los huéspedes de ESTE alojamiento: cada uno tiene los suyos, y de
                       ellos dependen el recargo por huésped extra y los cargos por
                       persona. Con botones y no con un campo suelto: se toca una vez. -->
                  <div class="rm-unit__guests" :title="$t('bookingsHc.rerservationModal.unitsGuests')">
                    <button
                      type="button"
                      class="rm-unit__step"
                      :disabled="extra.guests <= 1"
                      @click="cambiarHuespedesDeUnidad(i, -1)"
                    >−</button>
                    <span class="rm-unit__n">
                      <i class="fal fa-user rm-unit__user" aria-hidden="true"></i>
                      {{ extra.guests }}
                    </span>
                    <button type="button" class="rm-unit__step" @click="cambiarHuespedesDeUnidad(i, 1)">+</button>
                  </div>

                  <button
                    type="button"
                    class="rm-unit__del"
                    :title="$t('bookingsHc.rerservationModal.unitsRemove')"
                    :aria-label="$t('bookingsHc.rerservationModal.unitsRemove')"
                    @click="quitarUnidad(i)"
                  >
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </transition-group>

              <!-- El desplegable del sistema va encima, invisible: se conserva el
                   selector nativo —que en un móvil es el bueno— sin su caja gris. -->
              <label v-if="hermanosLibres.length" class="rm-addunit">
                <i class="fal fa-plus rm-addunit__ic" aria-hidden="true"></i>
                <span class="rm-addunit__tx">{{ $t("bookingsHc.rerservationModal.unitsAdd") }}</span>
                <select
                  class="rm-addunit__select"
                  :aria-label="$t('bookingsHc.rerservationModal.unitsAdd')"
                  @change="anadirUnidad($event.target.value); $event.target.value = ''"
                >
                  <option value="">{{ $t("bookingsHc.rerservationModal.unitsAdd") }}</option>
                  <option v-for="h in hermanosLibres" :key="h.id" :value="h.id">{{ h.displayName }}</option>
                </select>
              </label>
            </div>
          </div>

          <!-- Cantidad (hotel) -->
          <div class="rm-field" v-if="isHotel && selectedProperty">
            <label class="rm-label">{{ $t("modal.quantity") }}</label>
            <div class="rm-stepper">
              <button
                type="button"
                class="rm-stepper__btn"
                :disabled="quantity <= 1"
                @click="decQty"
              >
                <i class="fal fa-minus"></i>
              </button>
              <input
                type="number"
                class="rm-stepper__val"
                v-model.number="quantity"
                min="1"
                :max="selectedRoomTypeInfo.available_instances || 1"
                @input="checkQuantity()"
              />
              <button
                type="button"
                class="rm-stepper__btn"
                :disabled="quantity >= (selectedRoomTypeInfo.available_instances || 1)"
                @click="incQty"
              >
                <i class="fal fa-plus"></i>
              </button>
            </div>
          </div>

          <!-- Fechas. Las noches se cuentan AQUÍ, sobre el campo de salida, en vez de
               ocupar una fila entera debajo: es un dato de las fechas, no un paso más
               del formulario, y el modal ya es largo. -->
          <div class="rm-grid-2 rm-grid-2--fechas">
            <transition name="rm-nights">
              <span v-if="staySummaryText" class="rm-nights">
                <i class="fal fa-moon"></i>
                {{ staySummaryText }}
              </span>
            </transition>

            <div class="rm-field" style="grid-column: 1 / -1; width: 100%">
              <label class="rm-label">{{ $t("modal.arrival") }} → {{ $t("modal.departure") }}</label>
              <RangoDeFechas contorno :desde="startDate" :hasta="endDate" :min-dias="1" :disabled="isEditing && isOtaBooking" bloque @change="startDate = $event.from; endDate = $event.to; clearError('dates')" />
            </div>
          </div>

          <!-- Nombre del huésped, con el botón de buscar en Clientes -->
          <div class="rm-field rm-guest" ref="guestAutocompleteWrap">
            <label class="rm-label">{{ $t("modal.guestName") }}</label>
            <div class="rm-guest__control">
              <input
                type="text"
                class="rm-input"
                :class="{ 'rm-input--err': errors.name }"
                v-model="name"
                :placeholder="$t('modal.guestName')"
                autocomplete="off"
                @input="clearSelectedGuest(); clearError('name')"
              />
              <button
                v-if="!isEditing"
                type="button"
                class="rm-guest__btn"
                :class="{ 'rm-guest__btn--on': showGuestSuggestions || selectedGuestSuggestionId }"
                :title="$t('clientesDir.picker.searchSaved')"
                :aria-label="$t('clientesDir.picker.searchSaved')"
                :aria-expanded="String(showGuestSuggestions)"
                @click="toggleGuestPicker"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <circle cx="10" cy="8" r="4" />
                  <path d="M3 20c0-3.3 3-6 7-6 1 0 1.9.2 2.8.5" />
                  <circle cx="17.5" cy="16.5" r="3" />
                  <path d="m21.5 20.5-1.8-1.8" />
                </svg>
              </button>
            </div>
            <div v-if="showGuestSuggestions" class="rm-guest__list">
              <div class="rm-guest__search">
                <input
                  ref="guestPickerInput"
                  v-model="guestPickerQuery"
                  type="text"
                  class="rm-input"
                  autocomplete="off"
                  :placeholder="$t('clientesDir.picker.searchPlaceholder')"
                  @input="searchGuests"
                  @keydown.esc.stop.prevent="showGuestSuggestions = false"
                />
              </div>
              <div class="rm-guest__results">
                <div
                  v-if="guestSearchLoading && !guestSuggestions.length"
                  class="rm-guest__item rm-guest__item--loading"
                >
                  {{ $t("bookingsHc.rerservationModal.searchingGuests") }}
                </div>
                <div
                  v-else-if="!guestSuggestions.length"
                  class="rm-guest__item rm-guest__item--loading"
                >
                  {{ $t("clientesDir.picker.noResults") }}
                </div>
                <button
                  v-for="guest in guestSuggestions"
                  :key="guest.id"
                  type="button"
                  class="rm-guest__item"
                  @click="applyGuestSuggestion(guest)"
                >
                  <div class="rm-guest__main">{{ guest.label || $t("bookingsHc.rerservationModal.noName") }}</div>
                  <div class="rm-guest__meta">
                    <span v-if="guest.documento">{{ guest.documento }}</span>
                    <span v-if="guest.email">{{ guest.email }}</span>
                    <span v-if="guest.whatsapp">{{ guest.whatsapp }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>

          <!-- Email -->
          <div class="rm-field">
            <label class="rm-label">{{ $t("modal.email") }}</label>
            <input
              type="email"
              class="rm-input"
              :class="{ 'rm-input--err': errors.email }"
              v-model="email"
              :placeholder="$t('modal.email')"
              @input="clearError('email')"
            />
          </div>

          <!-- Teléfono -->
          <div class="rm-field">
            <label class="rm-label">{{ $t("modal.phone") }}</label>
            <vue-tel-input
              v-model="phone"
              :key="defaultCountryCode"
              :autoDefaultCountry="true"
              :defaultCountry="defaultCountryCode"
              :inputOptions="{ showDialCode: true }"
              class="rm-tel"
              :class="{ 'rm-input--err': errors.phone }"
              @input="(v, o) => { clearError('phone'); alCambiarTelefono(v, o); }"
            />
          </div>

          <!-- Número de huéspedes -->
          <div class="rm-field">
            <label class="rm-label">{{ $t("modal.guestsNumber") }}</label>
            <input
              type="number"
              class="rm-input"
              v-model="number_of_guests"
              min="1"
              :placeholder="$t('modal.guestsNumber')"
            />
          </div>

          <!-- Precio (destacado)
               Quien no ve importes puede crear la reserva —huésped, fechas, unidad—
               pero no le pone precio: lo completa después el anfitrión. Se oculta el
               campo entero y no solo la cifra, porque un recuadro de importe en blanco
               invita a escribir dentro. -->
          <div v-if="!ocultaImportes" class="rm-field rm-field--last">
            <label class="rm-label rm-label--price">
              {{ $t("modal.price") }}
              <span v-if="currencyCode" class="rm-label__cur">({{ currencyCode }})</span>
            </label>
            <div
              class="rm-price"
              :class="{ 'rm-price--locked': isEditing && isOtaBooking }"
            >
              <span class="rm-price__sym">{{ currencySymbol }}</span>
              <input
                type="number"
                class="rm-price__val"
                v-model.number="price"
                min="0"
                step="0.01"
                :disabled="isEditing && isOtaBooking"
                @input="precioAMano = true"
              />
            </div>
            <p v-if="isEditing && isOtaBooking" class="rm-lock">
              <i class="fal fa-lock"></i>
              {{ $t("bookingsHc.rerservationModal.priceLocked") }}
            </p>

            <!-- Otras opciones: la limpieza, los cargos y el descuento que el anfitrión
                 tiene configurados en su reserva directa. El precio de arriba son SOLO
                 las noches —lo mismo que enseña el calendario— y aquí se marca, una a
                 una, cada cosa que esta reserva lleva. Nada viene puesto: cobrar de más
                 por una casilla que venía marcada es peor que cobrar de menos por una
                 que se olvidó, y un descuento que se aplica solo no se entiende. -->
            <div v-if="hayOpcionales" class="rm-extras" :class="{ 'is-open': otrasOpciones }">
              <button type="button" class="rm-extras__head" @click="alternarOtrasOpciones">
                <span class="rm-extras__tx">
                  <span class="rm-extras__title">{{ $t("bookingsHc.rerservationModal.extrasTitle") }}</span>
                  <span class="rm-extras__sub">{{ $t("bookingsHc.rerservationModal.extrasSub") }}</span>
                </span>

                <span class="rm-extras__switch" :class="{ 'is-on': otrasOpciones }" role="switch" :aria-checked="String(otrasOpciones)">
                  <span class="rm-extras__dot"></span>
                </span>
              </button>

              <div class="rm-extras__wrap">
                <div class="rm-extras__inner">
                  <ul class="rm-extras__list">
                    <template v-for="linea in cotizaciones">
                      <li v-if="hayVariasUnidades && hayOpcionalesEn(linea)" :key="'u' + linea.property_id" class="rm-extras__unit">
                        {{ linea.name }}
                      </li>

                      <li
                        v-if="extraDe(linea) > 0"
                        :key="'e' + linea.property_id"
                        class="rm-extras__item"
                        :class="{ 'is-on': opcionesDe(linea.property_id).conExtra }"
                        @click="alternarExtra(linea)"
                      >
                        <span class="rm-extras__check" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                        </span>
                        <span class="rm-extras__name">
                          {{ $tc("bookingsHc.rerservationModal.quoteExtraGuest", huespedesExtraDe(linea), { count: huespedesExtraDe(linea) }) }}
                        </span>
                        <span class="rm-extras__amount">{{ formatMoney(extraDe(linea), linea.currency) }}</span>
                      </li>

                      <li
                        v-if="limpiezaDe(linea) > 0"
                        :key="'l' + linea.property_id"
                        class="rm-extras__item"
                        :class="{ 'is-on': opcionesDe(linea.property_id).conLimpieza }"
                        @click="alternarLimpieza(linea)"
                      >
                        <span class="rm-extras__check" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                        </span>
                        <span class="rm-extras__name">{{ $t("bookingsHc.rerservationModal.quoteCleaning") }}</span>
                        <span class="rm-extras__amount">{{ formatMoney(limpiezaDe(linea), linea.currency) }}</span>
                      </li>

                      <li
                        v-for="cargo in cargosDe(linea)"
                        :key="'c' + linea.property_id + claveDeCargo(cargo)"
                        class="rm-extras__item"
                        :class="{ 'is-on': opcionesDe(linea.property_id).cargos.includes(claveDeCargo(cargo)) }"
                        @click="alternarCargo(linea, cargo)"
                      >
                        <span class="rm-extras__check" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                        </span>
                        <span class="rm-extras__name">{{ claveDeCargo(cargo) }}</span>
                        <span class="rm-extras__amount">{{ formatMoney(cargo.amount, linea.currency) }}</span>
                      </li>

                      <!-- El descuento del anuncio. Se propone con su importe escrito,
                           pero no se aplica hasta que se marca, y el importe se puede
                           cambiar: es él quien decide cuánto rebaja. -->
                      <li
                        v-if="descuentoSugeridoDe(linea) > 0"
                        :key="'d' + linea.property_id"
                        class="rm-extras__item rm-extras__item--desc"
                        :class="{ 'is-on': opcionesDe(linea.property_id).conDescuento }"
                        @click="alternarDescuento(linea)"
                      >
                        <span class="rm-extras__check" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 6 9 17l-5-5" />
                          </svg>
                        </span>
                        <span class="rm-extras__name">
                          {{ descuentoEsPorOcupacion(linea)
                            ? $t("bookingsHc.rerservationModal.quoteOccupancyDiscount")
                            : $t("bookingsHc.rerservationModal.quoteDiscount") }}
                        </span>
                        <span class="rm-extras__edit" @click.stop>
                          <span class="rm-extras__minus">−</span>
                          <input
                            type="number"
                            class="rm-extras__input"
                            min="0"
                            step="0.01"
                            :value="opcionesDe(linea.property_id).descuento"
                            @input="escribirDescuento(linea, $event.target.value)"
                          />
                          <span class="rm-extras__cur">{{ currencySymbol }}</span>
                        </span>
                      </li>
                    </template>
                  </ul>

                </div>
              </div>
            </div>
          </div>

          <!-- Reenviar mensaje de confirmación (solo al modificar) -->
          <div v-if="isEditing" class="rm-resend">
            <label class="rm-resend__row">
              <input
                type="checkbox"
                class="rm-resend__cb"
                v-model="resendConfirmation"
              />
              <span class="rm-resend__tx">
                <span class="rm-resend__t">{{ $t("bookingsHc.rerservationModal.resendTitle") }}</span>
                <span class="rm-resend__s">
                  {{ $t("bookingsHc.rerservationModal.resendSub") }}
                </span>
              </span>
            </label>
            <transition name="rm-collapse">
              <div v-if="resendConfirmation" class="rm-resend__note">
                <i class="fas fa-circle-info"></i>
                <span v-html="$t('bookingsHc.rerservationModal.resendNote')"></span>
              </div>
            </transition>
          </div>
        </div>

        <!-- Footer -->
        <footer class="rm-foot">
          <button
            type="button"
            class="rm-btn rm-btn--ghost"
            @click="onUpdateVisible(false)"
          >
            {{ $t("modal.cancel") }}
          </button>
          <button
            type="button"
            class="rm-btn rm-btn--primary"
            :disabled="disableCreateBtn || isSubmitting || Loader"
            @click="saveReservation"
          >
            <span v-if="isSubmitting" class="rm-btn__spin"></span>
            <i v-else class="fal fa-check"></i>
            {{ isSubmitting ? $t("bookingsHc.rerservationModal.saving") : saveButtonLabel }}
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<!-- CSS base de vue-multiselect (selector con buscador) -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap");

/* Panel lateral derecho (drawer): cubre toda la altura y entra deslizándose.
   z-index alto para apilarse POR ENCIMA del drawer de detalle de reserva
   (PrimeVue Sidebar, ~12055) sin cerrarlo. */
.rm-overlay {
  position: fixed;
  inset: 0;
  z-index: 13050;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
  font-family: "DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  text-align: left;
}

.rm-dialog {
  width: 100%;
  max-width: 480px;
  height: 100vh;
  max-height: 100vh;
  background: #fff;
  border-radius: 0;
  box-shadow: -18px 0 50px rgba(15, 23, 42, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  transition: transform 0.34s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform;

  &--mobile { max-width: 100%; }
}

/* Header */
.rm-head {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 19px 22px;
  border-bottom: 1px solid #f1f3f7;
}
.rm-head__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: rgba(74, 91, 212, 0.1);
  color: #4a5bd4;
  font-size: 18px;
  flex-shrink: 0;
}
.rm-head__tx { flex: 1; min-width: 0; }
.rm-head__title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;
}
.rm-head__sub {
  margin: 2px 0 0;
  font-size: 13px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rm-head__close {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 19px;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: all 0.15s;
  flex-shrink: 0;
  &:hover { background: #f1f3f7; color: #475569; }
}

/* Body */
.rm-body { padding: 20px 22px 6px; overflow-y: auto; }

.rm-alert {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  border-radius: 11px;
  padding: 11px 13px;
  margin-bottom: 14px;
  font-size: 13px;
  line-height: 1.4;
  i { margin-top: 1px; font-size: 14px; flex-shrink: 0; }
}
.rm-alert--info { background: #eff6ff; border: 1px solid #bfdbfe; color: #1e40af; }
.rm-alert--danger { background: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; }

.rm-field { margin-bottom: 16px; }
.rm-field--last { margin-bottom: 8px; }

.rm-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 7px;
}
.rm-label--price { display: flex; align-items: center; gap: 6px; }
.rm-label__cur { font-weight: 500; color: #94a3b8; font-size: 12px; }

.rm-input {
  width: 100%;
  height: 46px;
  border: 1px solid #e3e8ef;
  border-radius: 11px;
  padding: 0 14px;
  font-size: 14.5px;
  color: #0f172a;
  background: #fff;
  font-family: inherit;
  transition: border-color 0.15s, box-shadow 0.15s;
  &::placeholder { color: #b4bcc9; }
  &:focus {
    outline: none;
    border-color: #4a5bd4;
    box-shadow: 0 0 0 3px rgba(74, 91, 212, 0.12);
  }
  &:disabled { background: #f8fafc; color: #94a3b8; cursor: not-allowed; }
}
.rm-input--err {
  border-color: #dc2626 !important;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;
}

.rm-select-wrap { position: relative; }
.rm-select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 38px;
  cursor: pointer;
}
.rm-select-caret {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 13px;
  pointer-events: none;
}

.rm-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

.rm-stepper {
  display: inline-flex;
  align-items: center;
  height: 46px;
  border: 1px solid #e3e8ef;
  border-radius: 11px;
  overflow: hidden;
}
.rm-stepper__btn {
  width: 44px;
  height: 100%;
  border: none;
  background: #f8fafc;
  color: #475569;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  &:hover:not(:disabled) { background: #eef1f6; color: #4a5bd4; }
  &:disabled { opacity: 0.4; cursor: not-allowed; }
}
.rm-stepper__val {
  width: 64px;
  height: 100%;
  border: none;
  border-left: 1px solid #e3e8ef;
  border-right: 1px solid #e3e8ef;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  &:focus { outline: none; }
}

/* Encima del campo de salida, a la altura de su etiqueta: se lee junto a las fechas
   y no roba una fila al formulario. */
.rm-grid-2--fechas { position: relative; }

.rm-nights {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  background: #f3f5fd;
  color: #4a5bd4;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.5;
}

.rm-nights-enter-active,
.rm-nights-leave-active { transition: opacity 180ms ease, transform 180ms cubic-bezier(0.16, 1, 0.3, 1); }
.rm-nights-enter,
.rm-nights-leave-to { opacity: 0; transform: translateY(-4px); }

.rm-lock {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: #b45309;
  margin: 7px 0 0;
}

/* ── Los alojamientos añadidos ───────────────────────────────────────────────
   Una tarjeta por alojamiento, con sus huéspedes y su aspa. El «añadir» es una
   línea discontinua: dice «aquí falta algo por elegir» con el mismo lenguaje que
   una zona donde soltar. */
.rm-units { margin-top: 10px; }

.rm-units__list { position: relative; display: flex; flex-direction: column; gap: 8px; }

.rm-unit {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px 9px 12px;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.rm-unit__ic {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #f3f5fd;
  color: #5e72e4;
  font-size: 13px;
}

.rm-unit__name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #3d4266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* El contador de huéspedes: el mismo gesto que el de cantidad del hotel. */
.rm-unit__guests {
  flex: none;
  display: inline-flex;
  align-items: center;
  height: 32px;
  border: 1px solid #e3e8ef;
  border-radius: 9px;
  overflow: hidden;
  background: #fbfbfe;
}

.rm-unit__step {
  width: 28px;
  height: 100%;
  border: 0;
  background: transparent;
  color: #5e72e4;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background 150ms ease;
}

.rm-unit__step:hover:not(:disabled) { background: #eef1ff; }
.rm-unit__step:disabled { color: #c7cbdd; cursor: default; }

.rm-unit__n {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 42px;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #2d3155;
}

.rm-unit__user { color: #9aa0b5; font-size: 11.5px; }

.rm-unit__del {
  flex: none;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #b1b6c9;
  font-size: 14px;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease;
}

.rm-unit__del:hover { background: #fdeef1; color: #c53350; }

/* Entra subiendo y sale encogiendo, para que se vea CUÁL se ha quitado. */
.rm-unit-enter-active,
.rm-unit-leave-active { transition: opacity 220ms ease, transform 220ms cubic-bezier(0.16, 1, 0.3, 1); }
.rm-unit-enter,
.rm-unit-leave-to { opacity: 0; transform: translateY(-6px); }
.rm-unit-leave-active { position: absolute; left: 0; right: 0; }

/* ── Añadir otro ─────────────────────────────────────────────────────────── */
.rm-addunit {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 8px 0 0;
  padding: 10px 12px;
  border: 1.5px dashed #ccd3e8;
  border-radius: 12px;
  color: #5e72e4;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease;
}

.rm-addunit:hover { border-color: #5e72e4; background: #f7f8ff; }

.rm-addunit__ic { font-size: 13px; }
.rm-addunit__tx { flex: 1 1 auto; }

/* El desplegable del sistema, encima y transparente: en un móvil abre su propia
   rueda —la que el operador ya conoce— sin heredar su caja gris. */
.rm-addunit__select {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

@media (prefers-reduced-motion: reduce) {
  .rm-unit-enter-active,
  .rm-unit-leave-active,
  .rm-unit__step,
  .rm-unit__del,
  .rm-addunit { transition: none; }
}

/* ── Otras opciones ──────────────────────────────────────────────────────────
   Un interruptor, no una lista siempre abierta: lo que casi nunca cambia no debe
   ocupar media pantalla. Encendido salen las cosas que se pueden cobrar, cada una
   con su propia casilla, y el precio de arriba se mueve con ellas. */
.rm-extras {
  margin-top: 12px;
  border: 1px solid #e7e9f3;
  border-radius: 14px;
  background: #fbfbfe;
  overflow: hidden;
}

.rm-extras__head {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 13px 14px;
  border: 0;
  background: transparent;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.rm-extras__tx { display: flex; flex-direction: column; gap: 2px; min-width: 0; }

.rm-extras__title {
  font-size: 13.5px;
  font-weight: 700;
  color: #2d3155;
}

.rm-extras__sub {
  font-size: 12px;
  line-height: 1.4;
  color: #8a90ad;
}

/* El interruptor del panel: mismo gesto que el resto de la casa. */
.rm-extras__switch {
  flex: none;
  margin-left: auto;
  position: relative;
  width: 42px;
  height: 24px;
  border-radius: 999px;
  background: #d9dced;
  transition: background 200ms ease;
}

.rm-extras__switch.is-on { background: #5e72e4; }

.rm-extras__dot {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.25);
  transition: transform 220ms cubic-bezier(0.16, 1, 0.3, 1);
}

.rm-extras__switch.is-on .rm-extras__dot { transform: translateX(18px); }

/* El pliegue crece hasta la altura REAL del contenido: sin medirla a mano ni un tope
   inventado que cortaría la lista de un anuncio con muchos cargos. */
.rm-extras__wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 280ms cubic-bezier(0.16, 1, 0.3, 1);
}

.rm-extras.is-open .rm-extras__wrap { grid-template-rows: 1fr; }

.rm-extras__inner {
  overflow: hidden;
  opacity: 0;
  transition: opacity 200ms ease;
}

.rm-extras.is-open .rm-extras__inner { opacity: 1; transition-delay: 70ms; }

/* `.rm-extras` delante a propósito. El panel carga una regla global de vuesax,
   `[dir] ul { margin: 0; padding: 0 }`, que pesa más que una clase sola: la lista se
   quedaba sin relleno y las tarjetas y el nombre del alojamiento iban pegados al borde
   mientras el título seguía a 14 px. Con dos clases ya no hay regla global que gane. */
.rm-extras .rm-extras__list {
  list-style: none;
  margin: 0;
  padding: 2px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rm-extras__unit {
  margin-top: 4px;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #9aa0b5;
}

/* Cada cosa que se puede cobrar es una tarjeta que se toca entera: en un móvil, un
   cuadradito de 15 px es un blanco imposible. */
.rm-extras__item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 11px 13px;
  border: 1.5px solid #e7e9f3;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: border-color 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.rm-extras__item:hover { border-color: #c9cfef; }

.rm-extras__item.is-on {
  border-color: #5e72e4;
  background: #f6f7ff;
  box-shadow: 0 0 0 3px rgba(94, 114, 228, 0.09);
}

.rm-extras__check {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21px;
  height: 21px;
  border: 1.5px solid #d3d7e8;
  border-radius: 7px;
  background: #fff;
  color: #fff;
  transition: background 180ms ease, border-color 180ms ease, transform 180ms cubic-bezier(0.16, 1, 0.3, 1);
}

.rm-extras__check svg { width: 13px; height: 13px; opacity: 0; transition: opacity 140ms ease; }

.rm-extras__item.is-on .rm-extras__check {
  background: #5e72e4;
  border-color: #5e72e4;
  transform: scale(1.04);
}

.rm-extras__item.is-on .rm-extras__check svg { opacity: 1; }

.rm-extras__name {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #3d4266;
}

.rm-extras__amount {
  flex: none;
  font-size: 13.5px;
  font-weight: 700;
  color: #2d3155;
  white-space: nowrap;
}

.rm-extras__item:not(.is-on) .rm-extras__amount { color: #a3a7bd; }

/* El único importe que se escribe: el del descuento. Se le da forma de campo pequeño
   alineado con los demás importes, para que se lea como una cifra más de la lista y
   no como un formulario aparte. */
.rm-extras__edit {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 1px;
  padding: 4px 9px;
  border: 1.5px solid #e7e9f3;
  border-radius: 9px;
  background: #fff;
  cursor: text;
  transition: border-color 180ms ease, box-shadow 180ms ease;
}

.rm-extras__item.is-on .rm-extras__edit { border-color: #c9d0f8; }

.rm-extras__edit:focus-within {
  border-color: #5e72e4;
  box-shadow: 0 0 0 3px rgba(94, 114, 228, 0.12);
}

.rm-extras__minus,
.rm-extras__cur {
  font-size: 13.5px;
  font-weight: 700;
  color: #2d3155;
}

.rm-extras__input {
  width: 58px;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 700;
  color: #2d3155;
  text-align: right;
  -moz-appearance: textfield;
}

.rm-extras__input::-webkit-outer-spin-button,
.rm-extras__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.rm-extras__item:not(.is-on) .rm-extras__minus,
.rm-extras__item:not(.is-on) .rm-extras__cur,
.rm-extras__item:not(.is-on) .rm-extras__input { color: #a3a7bd; }

.rm-extras__nota {
  margin: 0;
  padding: 0 14px 14px;
  font-size: 12px;
  line-height: 1.45;
  color: #8a90ad;
}

@media (prefers-reduced-motion: reduce) {
  .rm-extras__wrap,
  .rm-extras__inner,
  .rm-extras__dot,
  .rm-extras__check,
  .rm-extras__edit,
  .rm-extras__item { transition: none; }
}

/* La pista del traslado dice lo que SÍ se puede, no lo que está cerrado: en verde,
   para que no se lea como el candado del precio. */
.rm-hint-move {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: #0f766e;
  margin: 7px 0 0;
}
/* Mudanza a otro anuncio: el canal no se entera, y eso hay que leerlo antes de guardar. */
.rm-hint-move--otro {
  align-items: flex-start;
  color: #92400e;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 7px 9px;
  line-height: 1.4;
}

/* Autocomplete de huésped */
.rm-guest { position: relative; }
.rm-guest__control {
  position: relative;
  .rm-input { padding-right: 50px; }
}
.rm-guest__btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 9px;
  background: #f1f0fb;
  color: #673de6;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  &:hover { background: #e7e3fb; }
}
.rm-guest__btn--on { background: #673de6; color: #fff; &:hover { background: #5b32d0; } }
.rm-guest__list {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 40;
  background: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  box-shadow: 0px 0px 20px 3px rgba(17, 17, 17, 0.08);
  overflow: hidden;
}
.rm-guest__search {
  padding: 10px;
  border-bottom: 1px solid #f4f6fa;
  .rm-input { height: 40px; background: #f5f6f8; border-color: transparent; &:focus { background: #fff; } }
}
.rm-guest__results {
  max-height: 260px;
  overflow-y: auto;
}
.rm-guest__item {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: #fff;
  padding: 11px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f4f6fa;
  transition: background 0.12s;
  &:last-child { border-bottom: none; }
  &:hover { background: #f8fafc; }
}
.rm-guest__item--loading { color: #94a3b8; cursor: default; font-size: 13px; }
.rm-guest__main { font-size: 13.5px; font-weight: 700; color: #1f2733; }
.rm-guest__meta {
  margin-top: 3px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 12px;
  color: #94a3b8;
}

/* Precio destacado (valor oscuro/grande) */
.rm-price {
  display: flex;
  align-items: center;
  height: 54px;
  border: 1.5px solid #e3e8ef;
  border-radius: 12px;
  background: #fbfcfe;
  padding: 0 15px;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  &:focus-within {
    border-color: #4a5bd4;
    box-shadow: 0 0 0 3px rgba(74, 91, 212, 0.12);
    background: #fff;
  }
  &--locked { background: #f8fafc; }
}
.rm-price__sym {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
  margin-right: 9px;
}
.rm-price__val {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 21px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;
  font-family: inherit;
  &:focus { outline: none; }
  &:disabled { color: #94a3b8; }
}

/* Teléfono */
.rm-tel.vue-tel-input {
  height: 46px;
  border: 1px solid #e3e8ef;
  border-radius: 11px;
  box-shadow: none;
  &:focus-within {
    border-color: #4a5bd4;
    box-shadow: 0 0 0 3px rgba(74, 91, 212, 0.12);
  }
  .vti__input {
    border-radius: 0 11px 11px 0;
    font-size: 14.5px;
    color: #0f172a;
    font-family: inherit;
    background: transparent;
  }
  .vti__dropdown { border-radius: 11px 0 0 11px; }
  &.rm-input--err {
    border-color: #dc2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
  }
}

/* Footer */
.rm-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 22px;
  border-top: 1px solid #f1f3f7;
  background: #fff;
}
.rm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border-radius: 11px;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid transparent;
  font-family: inherit;
  transition: all 0.15s;
}
.rm-btn--ghost {
  background: #fff;
  color: #475569;
  border-color: #e3e8ef;
  &:hover { background: #f8fafc; color: #1f2733; }
}
.rm-btn--primary {
  background: #111827;
  color: #fff;
  box-shadow: 0 6px 16px rgba(17, 24, 39, 0.26);
  &:hover:not(:disabled) { background: #000; }
  &:disabled { opacity: 0.5; cursor: not-allowed; box-shadow: none; }
}
.rm-btn__spin {
  width: 15px;
  height: 15px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: rm-spin 0.6s linear infinite;
}
@keyframes rm-spin { to { transform: rotate(360deg); } }

/* Selector con buscador (vue-multiselect) */
.rm-ms { font-family: inherit; min-height: 46px; }
.rm-ms .multiselect__tags {
  min-height: 46px;
  padding: 13px 40px 0 14px;
  border: 1px solid #e3e8ef;
  border-radius: 11px;
  font-size: 14.5px;
}
.rm-ms .multiselect__single,
.rm-ms .multiselect__input {
  font-size: 14.5px;
  color: #0f172a;
  margin: 0;
  padding: 0;
  background: transparent;
  line-height: 1.4;
}
.rm-ms .multiselect__placeholder { color: #b4bcc9; font-size: 14.5px; padding: 0; margin: 0; }
.rm-ms.multiselect--active { z-index: 30; }
.rm-ms.multiselect--active .multiselect__tags {
  border-color: #4a5bd4;
  box-shadow: 0 0 0 3px rgba(74, 91, 212, 0.12);
}
.rm-ms .multiselect__select::before { border-color: #94a3b8 transparent transparent; }
.rm-ms .multiselect__content-wrapper {
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  margin-top: 6px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
  z-index: 31;
}
.rm-ms .multiselect__option { font-size: 14px; color: #1f2937; min-height: 0; padding: 11px 14px; }
.rm-ms .multiselect__option--highlight { background: #f3f5fd; color: #3d4cbb; }
.rm-ms .multiselect__option--highlight::after { display: none; }
.rm-ms .multiselect__option--selected { background: #fafbfd; font-weight: 700; color: #0f172a; }
.rm-ms .multiselect__option--selected.multiselect__option--highlight {
  background: #f3f5fd;
  color: #3d4cbb;
}
.rm-ms.multiselect--disabled { opacity: 0.6; }
.rm-ms.multiselect--disabled .multiselect__tags { background: #f8fafc; }
.rm-ms--err .multiselect__tags { border-color: #dc2626; box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1); }
.rm-ms__ic { color: #4a5bd4; margin-right: 7px; font-size: 13px; }
.rm-ms__nores { font-size: 13px; color: #94a3b8; padding: 4px 2px; display: block; }

/* Reenviar confirmación (checkbox al modificar) */
.rm-resend {
  margin-top: 6px;
  padding-top: 14px;
  border-top: 1px solid #f1f3f7;
}
.rm-resend__row {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  cursor: pointer;
  margin: 0;
}
.rm-resend__cb {
  width: 18px;
  height: 18px;
  margin-top: 1px;
  flex-shrink: 0;
  accent-color: #111827;
  cursor: pointer;
}
.rm-resend__tx { display: flex; flex-direction: column; gap: 2px; }
.rm-resend__t { font-size: 14px; font-weight: 600; color: #1f2733; line-height: 1.3; }
.rm-resend__s { font-size: 12.5px; color: #94a3b8; line-height: 1.35; }
.rm-resend__note {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 11px;
  padding: 11px 13px;
  border-radius: 11px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1e40af;
  font-size: 13px;
  line-height: 1.4;
  i { margin-top: 1px; font-size: 14px; flex-shrink: 0; }
}
.rm-collapse-enter-active, .rm-collapse-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.rm-collapse-enter, .rm-collapse-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* Transición: el panel entra deslizándose desde la derecha y el fondo hace fade.
   `appear` (en el <transition>) la dispara también en el primer render. La duración
   del overlay (0.36s) es ≥ la del panel (0.34s) para que el deslizamiento no se corte. */
.rm-pop-enter-active,
.rm-pop-leave-active,
.rm-pop-appear-active { transition: opacity 0.36s ease; }
.rm-pop-enter,
.rm-pop-leave-to,
.rm-pop-appear { opacity: 0; }
.rm-pop-enter .rm-dialog,
.rm-pop-leave-to .rm-dialog,
.rm-pop-appear .rm-dialog { transform: translateX(100%); }

@media (max-width: 600px) {
  .rm-grid-2 { grid-template-columns: 1fr; }
  .rm-dialog { max-width: 100%; }
}
</style>
